import styled, {css} from "styled-components";
import {styledByTheme} from "../../../themes/architecture/styled-by-theme";

interface IPaddingFixIosBoxProps {
    isIos: boolean;
}
const PaddingFixIosDefaultBox = styled.div<IPaddingFixIosBoxProps>``;

const PaddingFixIosSIBox = styled(PaddingFixIosDefaultBox)`
    ${props => props.isIos ? css`
        padding-top: 2px;
        ` : null}
`;

export const PaddingFixIosBox = styledByTheme(PaddingFixIosDefaultBox)
    .forSI(PaddingFixIosSIBox)
    .apply();